import { initializeApp, getApps, getApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyBZ7omtpXAEEd4AYDeUb5Ewzwpo_vkYVo8",
//   authDomain: "uncommon12-dev.firebaseapp.com",
//   projectId: "uncommon12-dev",
//   storageBucket: "uncommon12-dev.appspot.com",
//   messagingSenderId: "733302337885",
//   appId: "1:733302337885:web:fe0a6f43e42033b2d8b8b4"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDuYCIvD9bgoueqK9jI_fHypbXxIQZdy3I",
  authDomain: "uncommon12-3c8c2.firebaseapp.com",
  projectId: "uncommon12-3c8c2",
  storageBucket: "uncommon12-3c8c2.appspot.com",
  messagingSenderId: "1016243710225",
  appId: "1:1016243710225:web:ac2638e49bcbdfa19c84b0",
  measurementId: "G-6XGE7E0DSH"
};


const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

if (
  typeof window !== "undefined" &&
  process.env.NEXT_PUBLIC_USE_AUTH_EMULATOR === "true"
) {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
}
